// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PoTrx } from './po-trx';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoTrxHist extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key FK poTrx */
  poTrxId!: number;
  /** Int32 key */
  poDetailId!: number;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** DateTime */
  expectedDate?: Date;
  /** Int32 */
  heldQty?: number;
  /** Int32 */
  joDetailId?: number;
  /** Int32 */
  orderQty?: number;
  /** String(10) */
  poDetailTypeId?: string;
  /** Int32 */
  poHeaderId?: number;
  /** Int32 */
  prevPoTrxId?: number;
  /** Int32 */
  productId?: number;
  /** FK poTrxId */
  poTrx!: PoTrx;
}

